
import {initWebComponent} from "@/helpers/web-component-helper";
import {getActiveFilterFormAttributeByKey, getActiveFilterUrl} from "@/helpers/filter/filter-helper";
import {setUpListObserver} from "@/helpers/filter/filter-list-helper";
import {updateFilterBadge} from "@/helpers/filter/filter-settings-helper";

export class LayerInfoFilterSettingsListComponent extends HTMLElement {
    constructor(){
        super();

        const key = this.getAttribute('data-key')
        const formAttribute = getActiveFilterFormAttributeByKey(key)

        const template = document.createElement('template');
        template.innerHTML = `<select size="1" class="custom-select"></select>`;

        initWebComponent(this, template)

        setUpListObserver(this, formAttribute, true)

        this.addEventListener('change', (element) => {
            const value = element.target.value
            updateFilterBadge(this, value)
        })
    }
}
